import moment from "moment";
import { CurrencyFormat } from "../../../../../components/helpers";
import { Button } from "antd";

export const convertDisburseCommission = (data, handleOpenPreview) => {
  let converted = [];
console.log(data)
  if (!data) return [];
  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      dateTime: moment(item.created_at).format("DD/MM/YYYY HH:mm") || "-",
      customerName: item.customer_user.customer.ktp_name || "-",
      commissionTotal: `Rp ${CurrencyFormat(item.commission_amount)}` || "Rp 0",
      taxAmount: `Rp ${CurrencyFormat(item.tax_amount)}` || "Rp 0",
      feeAdmin: `Rp ${CurrencyFormat(item.admin_fee)}` || "Rp 0",
      commissionDisbursed: `Rp ${CurrencyFormat(item.total_amount)}` || "Rp 0",

      accountName: item.customer_user.customer_bank.account_name || "-",
      bankNameAndNumber:
        `${item.customer_user.customer_bank.bank_name.toUpperCase()} / ${
          item.customer_user.customer_bank.account_number
        }` || "-",
      transferProof: (
        <Button
          onClick={handleOpenPreview(
            `customer-membership/commission-status/proof-picture/${item?.last_status?.id}`
          )}
          type="link"
        >
          Lihat File
        </Button>
      ),
    });
  });
  return converted;
};
